import { render, staticRenderFns } from "./callBack.vue?vue&type=template&id=0dd4117c&"
import script from "./callBack.vue?vue&type=script&lang=js&"
export * from "./callBack.vue?vue&type=script&lang=js&"
import style0 from "./callBack.vue?vue&type=style&index=0&id=0dd4117c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports